import React from 'react';
import { FlowByFunction } from '@hud/portal-dtos/webapp-function.dto';
import { CellContext } from '@tanstack/react-table';
import {
  CellIcon,
  EntityWithIconContainer,
  TypeLabel,
} from './FlowCellRenderer.styles';
import { formatFlowType } from '../../utils';
import HoverPopover from '@hud/web-components/HoverPopover/HoverPopover';

export default function renderFlowType<TData extends FlowByFunction>(
  directFlows: FlowByFunction[],
) {
  return function CellRenderer(cell: CellContext<TData, string>) {
    return (
      <EntityWithIconContainer>
        {formatFlowType(cell.getValue())}
        {directFlows.find((flow) => flow.id === cell.row.original.id) && (
          <DirectLinkLabel />
        )}
      </EntityWithIconContainer>
    );
  };
}

function DirectLinkLabel() {
  return (
    <HoverPopover body="Directly called from" clickable={false}>
      <TypeLabel>
        <CellIcon icon="other.directLink" size="16px" className="after" />
        First
      </TypeLabel>
    </HoverPopover>
  );
}
